import { MouseEventHandler } from 'react'
import { IconName } from '../../types/icons'
import { ReactSVG } from 'react-svg'

export interface IconSvgProps {
	icon: IconName
	className?: string
	width?: number
	height?: number
	title?: string
	onClick?: MouseEventHandler<any>
}

export function IconSvg({ icon, width, height, title, onClick, ...props }: IconSvgProps) {
	return (
		<ReactSVG
			{...props}
			src={`/images/common/icon-svg/icon-${icon}.svg`}
			onClick={onClick}
			// A known size is reserved before the SVG is fetched, so the layout does not shift when it arrives.
			style={{
				cursor: onClick ? 'pointer' : 'inherit',
				width,
				height,
			}}
			beforeInjection={svg => {
				let style = ''
				if (width) {
					style += `width: ${width}px;`
				}
				if (height) {
					style += `height: ${height}px;`
				}

				svg.setAttribute('style', style)
			}}
			title={title}
		/>
	)
}
